// extracted by mini-css-extract-plugin
module.exports = {"dynamic-buttons":"DynamicButtons_dynamic-buttons___ABTX","dynamic-buttons__wrapper":"DynamicButtons_dynamic-buttons__wrapper__rl9jf"};